var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
import { Modal } from "react-bootstrap";
import padding from "@irati/ui/src/global/padding";
export var StyledModal = styled(Modal)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  .modal-dialog{\n    text-align: center;\n    padding: ", ";\n    ", "\n    width: auto !important;\n    margin: auto;\n  }\n  .modal-content{\n    margin-top: 100px;\n    padding: ", ";\n  }\n"], ["\n  .modal-dialog{\n    text-align: center;\n    padding: ", ";\n    ", "\n    width: auto !important;\n    margin: auto;\n  }\n  .modal-content{\n    margin-top: 100px;\n    padding: ", ";\n  }\n"])), padding.base, function (_a) {
    var maxWidth = _a.maxWidth;
    return maxWidth && "max-width: " + maxWidth + ";";
}, padding.large);
export var Img = styled.img(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-top: -175px;\n"], ["\n  margin-top: -175px;\n"])));
var templateObject_1, templateObject_2;
